<script>
import { ShoppingCartIcon , UserPlusIcon, PenToolIcon} from '@zhuowenli/vue-feather-icons'

export default {
  setup() {
    return {
      projectsWidgets: [
        {
          id: 1,
          feaIcon: "users",
          feaIconClass: "warning",
          label: "Active Customers",
          counter: "825",
          suffix: "",
          badgeClass: "danger",
          icon: " ri-user-add-line",
          percentage: "5.02 %",
          caption: "Active customers this month",
        },
        {
          id: 2,
          feaIcon: "shoppingcart",
          feaIconClass: "primary",
          label: "Total Orders",
          counter: "7522",
          separator: ",",
          suffix: "",
          badgeClass: "success",
          icon: "ri-shopping-cart-line",
          percentage: "3.58 %",
          caption: "Total customer orders this month",
        },
        {
          id: 3,
          feaIcon: "contract",
          feaIconClass: "info",
          label: "Contracts",
          counter: "5477",
          suffix: "m",
          badgeClass: "danger",
          icon: " ri-file-edit-line",
          percentage: "10.35 %",
          caption: "No of contracts signed this month",
        },
      ],
    };
  },
  components: {
    ShoppingCartIcon,
    UserPlusIcon,
    PenToolIcon
  },
};
</script>

<template>
  <div class="col-xl-4" v-for="(item, index) of projectsWidgets" :key="index">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="avatar-sm flex-shrink-0">
            <span
              class="avatar-title rounded-2 fs-2"
              :class="{
                'bg-soft-primary text-primary': item.feaIconClass === 'primary',
                'bg-soft-warning text-warning': item.feaIconClass === 'warning',
                'bg-soft-info text-info': item.feaIconClass === 'info'
              }"
            >
            <template v-if="item.feaIcon == 'shoppingcart'">
              <ShoppingCartIcon size="24" class="text-primary"></ShoppingCartIcon>
              </template>

              <template v-if="item.feaIcon == 'users'">
              <UserPlusIcon  size="24" class="text-warning"></UserPlusIcon>
              </template>

              <template v-if="item.feaIcon == 'contract'">
              <PenToolIcon size="24" class="text-info"></PenToolIcon>
              </template>
            </span>
          </div>
          <div class="flex-grow-1 overflow-hidden ms-3">
            <p class="text-uppercase fw-medium text-muted text-truncate mb-3">
              {{ item.label }}
            </p>
            <div class="d-flex align-items-center mb-3">
              <h4 class="fs-4 flex-grow-1 mb-0">
                <span class="counter-value">{{
                  item.counter
                }}</span>
              </h4>
              <span :class="`badge badge-soft-${item.badgeClass} fs-12`"
                ><i
                  :class="`${
                    item.icon
                  } fs-13 align-middle me-1`"
                ></i
                >{{ item.percentage }}</span
              >
            </div>
            <p class="text-muted text-truncate mb-0">{{ item.caption }}</p>
          </div>
        </div>
      </div>
      <!-- end card body -->
    </div>
  </div>
</template>
